import { ClientAttachmentId } from 'owa-client-ids';
import EventEmitter from 'owa-event-emitter';
import { SxSViewState } from 'owa-sxsdata';
import PendingOperationState from './PendingOperationState';
import SxSEditState from './SxSEditState';
import SxSExtendedViewState from './SxSExtendedViewState';
import SxSReadingPaneState from './SxSReadingPaneState';

export enum SxSCustomization {
    Mail,
    FilesHub,
    DeepLink,
    GroupFilesHub,
}

interface SxSStore {
    shouldShow: boolean;
    viewState: SxSViewState;
    extendedViewState: SxSExtendedViewState;
    editState: SxSEditState;
    customPreviewState: any;
    eventManager: EventEmitter;
    pendingPreviewOperation: PendingOperationState;
    pendingNavigation: { toAttachmentId: ClientAttachmentId; triggerTime: number };

    readingPaneState: SxSReadingPaneState;
    composeId: string;
    customization: SxSCustomization;
    isInvisible: boolean;

    shouldUseFakeRightHandSide: boolean;
    isUsingFakeRightHandSide: boolean;
    shouldHideReadingPaneOutsideSxS: boolean;

    attachmentViewStateIdFromListView: string;

    sessionPreviewCount: number;
    sessionStartTime: number;
}

export default SxSStore;
